import React, {Component} from "react";
import {connect} from "react-redux";
import {Field, reduxForm, submit} from "redux-form/immutable";
import ActionButton from "../../ActionButton";
import FormFieldsTable from "../../forms/FormFieldsTable";
import TextInputField from "../../forms/TextInputField";
import {Map} from "immutable";
import {validatePresence} from "../../../lib/Validators";
import {cancelChangeWarehouseContact, changeWarehouseContact} from "../../../actions/InventoryApiActions";
import {getSubmitInfoForCommand, getWarehouseWithId} from "../../../reducers/inventoryReducer";
import {isSubmitting, submitLabel} from "../../../lib/CommandStatus";

function validateForm(values) {
  let errors = Map();
  errors = validatePresence(errors, values, "id");
  errors = validatePresence(errors, values, "company");
  errors = validatePresence(errors, values, "contact_name");
  return errors.toJS();
}

class WarehouseContactForm extends Component {

  render() {
    let {handleSubmit, submit, submitInfo} = this.props;

    return (
      <form onSubmit={handleSubmit}>
        <div className="fields">
          <FormFieldsTable>
            <Field 
              label="Company or Name"
              name="company_name"
              component={TextInputField}
              />
            <Field
              label="Contact Name"
              name="contact_name"
              component={TextInputField}
              />
            <Field
              label="Telephone"
              name="contact_phone"
              component={TextInputField}
              />
            <Field
              label="Email"
              name="contact_email"
              component={TextInputField}
              />
          </FormFieldsTable>
        </div>
        <div className="buttons">
          <ActionButton label={submitLabel(submitInfo, "Submit")} onClick={submit} active={!isSubmitting(submitInfo)} />
          <ActionButton label="Cancel" active={!isSubmitting(submitInfo)} onClick={this.props.cancelChangeWarehouseContact} />
        </div>
      </form>
    )
  }
}

const ReduxForm = reduxForm({
  form: "WarehouseContactForm",
  validate: validateForm
})(WarehouseContactForm);

const ConnectedForm = connect(
  (state, ownProps) => {
    const warehouse = getWarehouseWithId(state.get("inventory"), ownProps.id);
    return {
      submitInfo: getSubmitInfoForCommand(state.get("inventory"), "ChangeWarehouseContact"),
      initialValues: {
        id: warehouse.get("id", ""),
        company_name: warehouse.get("company_name", ""),
        contact_name: warehouse.get("contact_name", ""),
        contact_phone: warehouse.get("contact_phone", ""),
        contact_email: warehouse.get("contact_email", "")
      }
    }
  },
  {
    cancelChangeWarehouseContact,
    submit,
    onSubmit: (data) => changeWarehouseContact(data, "WarehouseContactForm")
  }
)(ReduxForm);

export default ConnectedForm;